module.exports = __webpack_public_path__ + "img/ico-chevron-left.de936f56.svg";